import { KIOSK_FETCH_KIOSK_TYPES } from '../action-types/kiosks-types';

const initialState = {
  entities: [],
  loading: false,
  loaded: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case KIOSK_FETCH_KIOSK_TYPES.REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case KIOSK_FETCH_KIOSK_TYPES.SUCCESS:
      return {
        ...state,
        entities: action.payload.data.kiosk_types,
        loading: false,
        loaded: true,
      };
    case KIOSK_FETCH_KIOSK_TYPES.REJECTED:
      return {
        ...state,
        entities: [],
        loading: true,
        loaded: false,
      };
    default:
      return state;
  }
}
